<template>
  <div v-if="converted !== null" :class="columnClass">
    <small class="form-label w-100">
      <strong>{{
        $t("exchangeRates.columns.converted", { currency: systemLabel })
      }}</strong>
    </small>
    <br />
    <span
      class="view-number currency-display d-inline-block text-end"
      :title="rateTitle"
    >
      <span class="currency-value">{{ formattedConverted }}</span>
      <span class="currency-symbol ms-1">{{ systemLabel }}</span>
    </span>
  </div>
</template>

<script>
import { formatNumberSync } from "@/utils/numberFormatter";
import { fetchOperationRates, operationRateFor } from "../utils/operationRates";

/**
 * Columna «En USD» de una línea de gastos del embarque (ticket #397): el importe del
 * gasto en la moneda del sistema con el tipo de cambio de la operación. Solo aparece si
 * exchange_rates_module está activo y el gasto está en otra moneda.
 */
export default {
  name: "OperationUsdEquivalent",
  props: {
    shippingId: { type: String, default: "" },
    amount: { type: [Number, String], default: null },
    currencyId: { type: [String, Object], default: null },
    /** Mismas clases de columna que los demás campos de la fila. */
    columnClass: { type: [String, Object, Array], default: "" },
    lists: { type: Array, default: () => [] },
  },
  data() {
    return { fx: null };
  },
  computed: {
    currencyKey() {
      const c = this.currencyId;
      if (c === null || c === undefined || c === "") return "";
      return typeof c === "object" && c._id != null ? String(c._id) : String(c);
    },
    rate() {
      return operationRateFor(this.fx, this.currencyKey);
    },
    converted() {
      if (!this.fx || !this.fx.enabled || !this.currencyKey) return null;
      if (this.currencyKey === String(this.fx.systemCurrencyId)) return null;
      const amount = Number(this.amount);
      if (!this.rate || !Number.isFinite(amount)) return null;
      return amount * this.rate;
    },
    formattedConverted() {
      return formatNumberSync(this.converted, null, true);
    },
    systemLabel() {
      return this.labelFor(this.fx && this.fx.systemCurrencyId) || "USD";
    },
    rateTitle() {
      const from = this.labelFor(this.currencyKey);
      const rate = Number(this.rate).toLocaleString(undefined, {
        maximumFractionDigits: 6,
      });
      return this.$t("exchangeRates.columns.convertedHint", {
        from,
        to: this.systemLabel,
        rate,
      });
    },
  },
  watch: {
    shippingId: { handler: "load", immediate: true },
    currencyKey: "load",
  },
  methods: {
    labelFor(id) {
      const list = (this.lists || []).find((l) => l && l.type === "currency");
      const found =
        list && (list.values || []).find((v) => String(v._id) === String(id));
      return found ? String(found.label || "") : "";
    },
    async load() {
      if (!this.shippingId || !this.currencyKey) {
        this.fx = null;
        return;
      }
      this.fx = await fetchOperationRates(this.shippingId, [this.currencyKey]);
    },
  },
};
</script>
